import { useStorage } from './use-storage';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useLocalStorage = <T>(key: string, initialValue?: T) => {
	return useStorage<T>('localStorage', key, initialValue);
};
